import { useEffect, useState } from "react";
import http from "../lib/http";

import {
  FaStar,
  FaCommentDots,
  FaCheckCircle,
  FaClock
} from "react-icons/fa";

import StatCard from "../components/Statcard";

export default function DealerDashboardPage() {

  const dealer =
    JSON.parse(localStorage.getItem("dealer"));

  const [stats, setStats] = useState({
    totalReviews: 0,
    approvedReviews: 0,
    pendingReviews: 0,
    leads:0,
    avgRating: 0
  });

  const [recentReviews, setRecentReviews] =
    useState([]);
  
  const [subscription, setSubscription] =
  useState(null);

  useEffect(() => {

    loadDashboard();

  }, []);

  const loadDashboard = async () => {

    try {

      const res =
        await http.get(
            "/api/dealer-portal/dashboard",
            {
              params:{
                dealerId: dealer._id
              }
            }
          );

      setStats(res.data);

      const reviewRes =
                await http.get(
          "/api/dealer-portal/reviews",
          {
            params:{
              dealerId: dealer._id
            }
          }
        );

      setRecentReviews(
        reviewRes.data.slice(0, 5)
      );

      const subRes =
        await http.get(
          `/api/dealers/${dealer._id}/subscription-status`
        );

      setSubscription(
        subRes.data
      );

    } catch (err) {

      console.error(err);

    }

  };

  const daysLeft =
  subscription?.daysLeft || 0;

  return (

    <>
    {subscription && (

      <div
        className="card-modern mb-4"
        style={{
          borderLeft:
            daysLeft <= 3
              ? "5px solid #dc3545"
              : daysLeft <= 7
              ? "5px solid #ffc107"
              : "5px solid #198754"
        }}
      >

        <div className="d-flex justify-content-between align-items-center">

          <div>

            <h5 className="mb-2">
              Subscription Status
            </h5>

            <div>
              <strong>Plan:</strong>
              {" "}
              {subscription.plan}
            </div>

            <div>
              <strong>Valid Till:</strong>
              {" "}
              {new Date(
                subscription.expiryDate
              ).toLocaleDateString()}
            </div>

            <div>
              <strong>Days Left:</strong>
              {" "}
              {daysLeft}
            </div>

          </div>

          <div>

            {subscription.status ===
            "EXPIRED" ? (

              <span className="badge bg-danger fs-6">
                Expired
              </span>

            ) : (

              <span className="badge bg-success fs-6">
                Active
              </span>

            )}

          </div>

        </div>

      </div>

    )}

    {subscription &&
        subscription.status === "ACTIVE" &&
        daysLeft <= 7 &&
        daysLeft > 0 && (

          <div
            className={`alert ${
              daysLeft <= 3
                ? "alert-danger"
                : "alert-warning"
            }`}
          >

            {daysLeft <= 3
              ? `🚨 Your subscription expires in ${daysLeft} days.`
              : `⚠ Your subscription expires in ${daysLeft} days.`}

            {" "}
            Please contact BuildNear Admin for renewal.

          </div>

        )}
        
        {subscription &&
          subscription.status === "EXPIRED" && (

            <div className="alert alert-danger">

              <h6 className="mb-1">
                Subscription Expired
              </h6>

              <div>
                Your subscription has expired.
                Please contact BuildNear Admin
                to continue receiving leads.
              </div>

            </div>

          )}
      <div className="dashboard-grid">

        <StatCard
          title="Total Reviews"
          value={stats.totalReviews}
          icon={<FaCommentDots />}
        />

        <StatCard
          title="Average Rating"
          value={stats.avgRating}
          icon={<FaStar />}
        />

        <StatCard
          title="Approved Reviews"
          value={stats.approvedReviews}
          icon={<FaCheckCircle />}
        />

        <StatCard
          title="Pending Reviews"
          value={stats.pendingReviews}
          icon={<FaClock />}
        />

        <StatCard
          title="Leads"
          value={stats.leads}
          icon={<FaClock />}
        />

      </div>

      <div className="card-modern mt-4">

        <h5 className="mb-3">
          Recent Reviews
        </h5>

        {recentReviews.length === 0 ? (

          <p>No reviews available</p>

        ) : (

          recentReviews.map(review => (

            <div
              key={review._id}
              className="border-bottom py-2"
            >
              <strong>
                {review.name}
              </strong>

              <div>
                ⭐ {review.rating}
              </div>

              <small>
                {review.comment}
              </small>
            </div>

          ))
        )}

      </div>
    </>
  );
}